import React, { FC } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';
import cn from 'classnames';
import useSearchInputFocusStore from 'src/hooks/useSearchInputFocusStore';
import useGTAG, { GTAGPrefix } from 'src/hooks/useGTAG';
import useHostStore from 'src/hooks/useHostStore';

const logoImage = 'shared/logo_v2.svg';

interface Props {
  classNameContainer?: string;
  gtagPrefix?: GTAGPrefix;
  isSmall?: boolean;
}

const Logo: FC<Props> = ({
  classNameContainer = '',
  gtagPrefix,
  isSmall = false
}) => {
  const { hostURL } = useHostStore();
  const { setSearchInputFocus } = useSearchInputFocusStore();
  const { trackGtagEvent } = useGTAG();

  return (
    <div
      className={cn(
        'logo flex-row items-center cursor-pointer',
        classNameContainer
      )}
    >
      <div itemScope itemType="http://schema.org/Organization" className="flex">
        <a itemProp="url" className="flex" href={hostURL}>
          <NextImage
            alt="Справочник лекарств LIKIE"
            title="Справочник лекарств"
            src={logoImage}
            layout="fixed"
            itemProp="logo"
            quality={100}
            width={isSmall ? 65 : 76}
            height={isSmall ? 24 : 28}
            priority
            onClick={() => {
              setSearchInputFocus(false);
              trackGtagEvent(`${gtagPrefix}_logo`);
            }}
          />
        </a>
      </div>
    </div>
  );
};

export default Logo;
